
import { DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { AlertCircle } from "lucide-react";

interface CompleteProfileModalHeaderProps {
  forceOpen?: boolean;
}

export const CompleteProfileModalHeader = ({ forceOpen = false }: CompleteProfileModalHeaderProps) => {
  return (
    <DialogHeader>
      <DialogTitle className="text-xl text-center pb-0 pt-5 mb-2 text-white flex items-center justify-center gap-2">
        {forceOpen && <AlertCircle className="h-5 w-5 text-[#00C1D6]" />}
        {forceOpen ? "Completa tu perfil para continuar" : "Completa tu perfil"}
      </DialogTitle>
      {forceOpen && (
        <p className="text-sm text-[#00C1D6] text-center">
          Solo Nombre, Apellido y Fecha de Nacimiento son obligatorios
        </p>
      )}
    </DialogHeader>
  );
};
